import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

// 业务费结算-查询列表
export async function rqtPostYearMonthCommissionList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 业务费结算-结算
export async function rqtPutAgentMonthCommissionSettlement(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/settlement`,
    METHOD.PUT_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

// 业务费结算-结转
export async function rqtPutAgentMonthCommissionForward(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/forward`,
    METHOD.PUT_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

// 业务费结算-删除
export async function rqtDeleteAgentMonthCommission(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/delete`,
    METHOD.DELETE_JSON_ENCRYPT,
    params
  )
}

// 业务费结算-导出
export async function rqtGetExportAgentMonthCommission(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}

// 综合查询-业务费查询
export async function rqtPostAgentMonthCommissionList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/agent/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-业务费查询-查询财富业务费明细
export async function rqtPostAgentMonthCommissionDtlList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommissiondtl/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-业务费查询-查询财富业务费管理奖金明细
export async function rqtPostAgentMonthManageBonusDtlList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommissiondtl/managebonus/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-业务费查询-查询保险业务费明细
export async function rqtPostAgentMonthInsCommissionDtlList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommissiondtl/ins/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-业务费查询-查询保险管理奖金
export async function rqtPostAgentMonthInsManageBonusDtlList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommissiondtl/ins/managebonus/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-业务费查询-查询英才奖&超额英才奖明细
export async function rqtPostAgentMonthEliteBonusDtlList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommissiondtl/elite/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 业务费结算-导出
export async function rqtGetExportAgentMonthCommissionDetail(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommission/search/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}

// 加扣款上传-查询列表接口
export async function rqtPostAgentMonthCommissionExtraList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommextradtl/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
//  加扣款上传-导出
export async function rqtGetAgentMonthCommissionExtraReport(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommextradtl/export`,
    METHOD.GET,
    params,
    { responseType: 'blob' }
  )
}
//  加扣款上传-导入
export async function rqtPostAgentMonthCommissionExtraReport(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommextradtl/import`,
    METHOD.POST_JSON,
    params,
    { timeout: 600000 }
  )
}

// 加扣款附件上传-查询列表
export async function rqtPostMonthCommissionExtraAttachmentList(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommextradtl/attachment/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 加扣款附件上传-查询当月附件信息
export async function rqtPostMonthCommissionExtraAttachment(params) {
  return request(
    `${BASE_URL}/provider/ams/agentmonthcommextradtl/attachment`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 年终奖核算-查询列表
export async function rqtPostYearEndBonusList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 年终奖结算接口
export async function rqtPostSettlementYearEndBonusList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/settlement`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 年终奖结转
export async function rqtPostForwardYearEndBonusList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/forward`,
    METHOD.PUT_JSON_ENCRYPT,
    params,
    { timeout: 600000 }
  )
}

// 删除
export async function rqtDeleteYearEndBonus(id, params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/${id}`,
    METHOD.DELETE_JSON_ENCRYPT,
    params
  )
}

// 年终奖结算-导出
export async function rqtGetExportYearEndBonusExcel(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}

// 综合查询-年终奖列表
export async function rqtPostAgentYearEndBonusList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonusdetail/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-年终奖-年终奖明细
export async function rqtPostAgentYearEndBonusDetailList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonusdetail/detail/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-年终奖-管理奖金明细
export async function rqtPostAgentManageDetailList(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonusdetail/manage/detail/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

// 综合查询-年终奖-导出
export async function rqtGetExportYearEndBonusSearchExcel(params) {
  return request(
    `${BASE_URL}/provider/ams/yearendbonus/search/export`,
    METHOD.GET,
    params,
    { responseType: 'blob', timeout: 600000 }
  )
}
